import r from "../../shared-lib/braze-shared-lib.js";
import e from "../managers/braze-instance.js";
import {
  BRAZE_ACTIONS as P,
  getDecodedBrazeAction as _
} from "../util/braze-actions.js";
import {
  BRAZE_ACTION_URI_REGEX as J,
  isValidBrazeActionJson as O
} from "../util/validation-utils.js";
import { WindowUtils as H } from "../util/window-utils.js";
import { getUser as Q } from "./get-user.js";
export function _handleBrazeAction(s, o, i) {
  if (e.rr())
    if (J.test(s)) {
      const e = _(s);
      if (!e) return;
      const o = e => {
        if (!O(e))
          return void r.D.error(
            `Decoded Braze Action json is invalid: ${JSON.stringify(
              e,
              null,
              2
            )}`
          );
        const s = e[P.properties.type];
        if (s === P.types.ue) for (const r of e[P.properties.me]) o(r);
        else {
          const o = e[P.properties.fe];
          let i;
          switch (s) {
            case P.types.logCustomEvent:
              import("./log-custom-event.js").then(
                ({ logCustomEvent: logCustomEvent }) => {
                  logCustomEvent.apply(null, Array.prototype.slice.call(o));
                }
              );
              break;
            case P.types.requestPushPermission:
              import("../Push/request-push-permission.js").then(
                ({ requestPushPermission: requestPushPermission }) => {
                  requestPushPermission();
                }
              );
              break;
            case P.types.setEmailNotificationSubscriptionType:
            case P.types.setPushNotificationSubscriptionType:
            case P.types.setCustomUserAttribute:
            case P.types.addToSubscriptionGroup:
            case P.types.removeFromSubscriptionGroup:
            case P.types.addToCustomAttributeArray:
            case P.types.removeFromCustomAttributeArray:
              (i = Q()), i[s].apply(i, Array.prototype.slice.call(o));
              break;
            case P.types.de:
            case P.types.pe:
              H.openUri.apply(null, Array.prototype.slice.call(o));
              break;
            default:
              r.D.info(`Ignoring unknown Braze Action: ${s}`);
          }
        }
      };
      o(e);
    } else H.openUri(s, i, o);
}
export function handleBrazeAction(e, r) {
  _handleBrazeAction(e, r);
}
